import { html, utl_renderObjects } from "../base/_utils";
import { saacReps } from "../data/_saac-reps";

document.addEventListener("DOMContentLoaded", () => {
    utl_renderObjects({
        data: saacReps,
        template: (rep) => {
            if (rep.execBoard) {
                return html`
                    <div class="col">
                        <div class="card">
                            <img class="card-img-top" src="../${rep.image}" alt="${rep.name} headshot" />
                            <div class="card-footer d-flex flex-column justify-content-center text-center py-3 eh">
                                <h3 class="h6">${rep.title}</h3>
                                <p>${rep.name}, ${rep.sport}</p>
                            </div>
                        </div>
                    </div>
                `;
            }
        },
        target: "#exec-board-container",
    });

    utl_renderObjects({
        data: saacReps,
        template: (rep) => {
            if (!rep.execBoard) {
                return html`
                    <div class="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                        <div class="card">
                            <img class="card-img-top" src="../${rep.image}" alt="${rep.name} headshot" />
                            <div class="card-footer text-center align-content-center py-3 eh">
                                <p class="lh-1 mb-0"><strong>${rep.name}</strong><br /><small>${rep.sport}</small></p>
                            </div>
                        </div>
                    </div>
                `;
            }
        },
        target: "#other-reps-container",
    });
});
